<template>
  <div class="submit">
    <div class="submit-mask" v-show="visible" @click="visible = !visible"></div>
    <div
      class="submit-modal"
      :class="{ 'is-limited-exemption': isLimitedExemption }"
      v-show="visible"
    >
      <template v-if="isLimitedExemption">
        <div class="amount-line-item item">
          <span>儲值金額</span>
          <span class="line"></span>
          <span>{{ paymentAmount - taxation - commission }}</span>
        </div>
        <div class="item amount-line-item">
          <span>稅費(限免)</span>
          <span class="line"></span>
          <span>{{ taxation || 0 }}</span>
        </div>
        <div class="item amount-line-item">
          <span>手續費(限免)</span>
          <span class="line"></span>
          <span>{{ commission || 0 }}</span>
        </div>
      </template>
      <template v-if="!isLimitedExemption">
        <div class="amount-line-item item">
          <span>儲值金額</span>
          <span class="line"></span>
          <span>{{ paymentAmount - taxation - commission }}</span>
        </div>
        <div class="item flex-between">
          <span>稅費</span>
          <span>{{ taxation || 0 }}</span>
        </div>
        <div class="item flex-between">
          <span>手續費(由第三方金流收取)</span>
          <span>{{ commission || 0 }}</span>
        </div>
        <div class="flex-between activity" v-if="giftAmmount">
          <div>
            <span class="tag">限時活動</span>
            <span
              >送{{ giftAmmount }}鑽(價值{{ taxation + commission }}幣)</span
            >
          </div>
          <span>0</span>
        </div>
      </template>
    </div>
    <div class="submit-btn-box">
      <span class="price" v-if="paymentAmount"
        ><span class="tag">$</span>{{ paymentAmount }}</span
      >
      <div>
        <template v-if="paymentAmount">
          <span class="btn-dropdown" @click="toggleShowDetail"
            >明細
            <i class="el-icon-arrow-down" v-show="!visible"></i>
            <i class="el-icon-arrow-up" v-show="visible"></i>
          </span>
        </template>
        <button class="submit-button" @click="handleRecharge">
          確認儲值
          <i class="el-icon-loading" v-if="iapLoading"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Submit',
  props: {
    iapLoading: {
      type: Boolean,
      default: false
    },
    disableBtn: {
      type: Boolean,
      default: false
    },
    // 總支付金額
    paymentAmount: {
      type: Number,
      default: 0
    },
    // 稅費
    taxation: {
      type: Number,
      default: 0
    },
    // 手續費
    commission: {
      type: Number,
      default: 0
    },
    // 贈送金額
    giftAmmount: {
      type: Number,
      default: 0
    },
    // 贈送金額
    activitySwitch: {
      type: Boolean,
      default: false
    },
    // 贈送金額
    isPaypal: {
      type: Boolean,
      default: false
    },
    // 是否限免
    isLimitedExemption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleRecharge() {
      this.$emit('submit');
    },
    toggleShowDetail() {
      this.visible = !this.visible;
    }
  }
};
</script>
<style lang="scss" scoped>
@function changeRem($value) {
  @return $value / 12;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit {
  position: relative;
  font-size: 1.1rem;
  .item {
    margin-bottom: changeRem(26rem);
  }
  .submit-mask {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .submit-modal {
    height: changeRem(258rem);
    background: #ffffff;
    border-radius: changeRem(26rem) changeRem(26rem) 0px 0px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    padding: changeRem(30rem) 1.5rem changeRem(26rem);
    color: #7b7b7b;
    font-weight: 400;
    &.is-limited-exemption {
      height: changeRem(228rem);
    }
    .amount-line-item {
      display: flex;
      align-items: center;
      .line {
        flex: 1;
        width: 1px;
        display: inline-block;
        border-top: 1px dashed #cbcbcb;
        margin: 0 changeRem(12rem);
      }
    }
    .activity {
      color: #fc4688;
      > div {
        display: flex;
        align-items: center;
      }
      .tag {
        font-size: changeRem(12rem);
        padding: 0 changeRem(8rem);
        line-height: changeRem(20rem);
        background-color: #fc4688;
        border-radius: changeRem(10rem);
        color: white;
        display: inline;
        margin-right: 10px;
      }
    }
  }

  .submit-btn-box {
    position: relative;
    padding: 0 1.5rem;
    // margin-bottom: 1rem;
    height: changeRem(62rem);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 3;
    border-top: 1px solid #efefef;
    .price {
      font-size: changeRem(23rem);
      font-weight: 400;
      color: #fb9030;
      .tag {
        font-size: changeRem(18rem);
      }
    }
    .btn-dropdown {
      font-size: changeRem(12rem);
      font-weight: 400;
      color: #b0b0b0;
      padding: 1rem;
    }
    .submit-button {
      width: changeRem(168rem);
      height: changeRem(42rem);
      background: #f7da5c;
      border-radius: changeRem(18rem);
      font-size: changeRem(16rem);
      font-weight: 400;
      color: #0d0d0d;
    }
  }
}
</style>
